import axios from 'axios';
import Vue from 'vue'

export default {

    getInvoiceSettings () {
        return axios.get('/api/global-setting/invoice/list')
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getWithholdingTaxThreshold() {
        return axios.get('/api/global-setting/withholding-tax-threshold')
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveWithholdingTaxThreshold(threshold) {
        return axios.post('/api/global-setting/withholding-tax-threshold', {threshold: threshold})
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveInvoiceSettings(invoiceMailSettings){
        return axios.post('/api/global-setting/invoice/save', invoiceMailSettings)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPlatformMaintenance() {
        return axios.get('/api/global-setting/get/status/platform')
            .then(response => {
                if (response && response.data) return response.data;
            })
            .catch(error => { Vue.prototype.$snotify.error(error); });
    },

    savePlatformMaintenance(payload) {
        return axios.post('/api/global-setting/save/platform-maintenance', payload)
            .then(response => {
                if (response && response.data) {
                    Vue.prototype.$snotify.success('Mode maintenance mis à jour');
                    return response.data;
                }
            })
            .catch(error => { Vue.prototype.$snotify.error(error); });
    },

  
}
